document.addEventListener('DOMContentLoaded', () => {
    const icon = document.querySelector('.vayu_blocks-timeline__marker');
    if (icon) {
        const top = icon.offsetTop;

        const classmain = document.querySelector('.vayu-blocks-laytout-7-advance-timeline');
        if(classmain){
            classmain.style.setProperty('--vb-value-top-icon', `${top}px`);
        }

    }
});

